import React from 'react';
import PropTypes from 'prop-types';
import { TextField, IconButton, mergeStyleSets } from '@fluentui/react';

import { getValidSingleCellAddress } from 'shared/excel/excel';
import office from 'src/services/office';

import SpanWithTooltip from 'src/components/base/SpanWithTooltip';

const classNames = mergeStyleSets({
  root: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  },
  textField: {
    display: 'flex',
    flexDirection: 'row',
  },
  icon: {
    fontSize: '24px',
  }
});


const Data = {
  iconProps: { iconName: 'xappex-target', styles: { root: classNames.icon } },
  textFieldStyles: { wrapper: { width: 60, marginLeft: 8 }},
};


export const CellPicker = ({ value = 'A1', disabled, allowEmptyCell = false, onChange, label = '', tooltip = ''}) => {
  async function handleTargetClick() {
    onChange(await office.getSelectedRangeReference(), true);
  }

  function validateCellAddress(value) {
    return (allowEmptyCell && !value) || getValidSingleCellAddress(value) ? '' : 'Invalid Cell';
  }

  return (
    <div className={classNames.root}>
      { label && <SpanWithTooltip label={label} tooltip={tooltip} />}
      <div className={classNames.textField}>
        <IconButton
          disabled={disabled} 
          iconProps={Data.iconProps} 
          onClick={handleTargetClick} 
        />
        <TextField styles={Data.textFieldStyles}
          disabled={disabled}
          value={value.toLocaleUpperCase()}
          onChange={e => onChange(e.target.value, !validateCellAddress(e.target.value))}
          onGetErrorMessage={validateCellAddress}
        />
      </div>
    </div>
  )
}

CellPicker.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default CellPicker;
